module.exports = __webpack_public_path__ + "img/xqimg9.ded1e955.png";